var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 355,
    height: 355,
    viewBox: "0 0 355 355",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.48
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.6877 254.613L66.9941 258.919L71.3143 254.601L73.1603 256.446L68.8393 260.764L73.1484 265.07L71.2973 266.921L66.9878 262.615L62.6708 266.933L60.8248 265.087L65.1426 260.77L60.8366 256.463L62.6877 254.613Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M258.079 37.7727L262.386 42.0795L266.706 37.7608L268.552 39.6063L264.231 43.9242L268.54 48.2306L266.689 50.0813L262.379 45.7752L258.062 50.0931L256.216 48.2476L260.534 43.9305L256.228 39.6233L258.079 37.7727Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.72,
    d: "M181.873 310.137C182.684 309.329 183.781 308.875 184.926 308.875C186.07 308.875 187.168 309.329 187.978 310.137L191.052 313.21C191.455 313.611 191.776 314.089 191.994 314.613C192.213 315.138 192.326 315.702 192.326 316.271C192.326 316.84 192.213 317.403 191.994 317.928C191.776 318.453 191.457 318.929 191.054 319.329L187.978 322.405C187.168 323.213 186.07 323.667 184.926 323.667C183.781 323.667 182.684 323.213 181.873 322.405L178.8 319.332C178.397 318.931 178.075 318.453 177.857 317.928C177.638 317.403 177.526 316.84 177.526 316.271C177.526 315.702 177.639 315.139 177.857 314.613C178.075 314.089 178.395 313.613 178.797 313.212L181.873 310.137Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M286.064 115.495C286.064 115.495 286.064 115.495 286.064 115.495L282.99 118.569L281.691 117.27L282.986 118.573C282.926 118.633 282.878 118.704 282.845 118.782C282.813 118.86 282.796 118.944 282.796 119.029C282.796 119.113 282.813 119.197 282.845 119.275C282.878 119.354 282.926 119.425 282.986 119.484L282.99 119.488L286.064 122.562C286.064 122.562 286.064 122.562 286.064 122.562C286.186 122.683 286.351 122.752 286.523 122.752C286.695 122.752 286.86 122.684 286.981 122.563C286.981 122.563 286.982 122.563 286.981 122.563L290.061 119.484C290.121 119.425 290.168 119.354 290.201 119.275C290.234 119.197 290.25 119.113 290.25 119.029C290.25 118.944 290.234 118.86 290.201 118.782C290.168 118.704 290.121 118.633 290.061 118.573L290.057 118.569L286.982 115.495C286.982 115.495 286.982 115.495 286.982 115.495C286.86 115.374 286.695 115.305 286.523 115.305C286.351 115.305 286.186 115.374 286.064 115.495ZM280.395 115.97L283.471 112.895C284.281 112.087 285.379 111.633 286.523 111.633C287.668 111.633 288.765 112.087 289.576 112.895L289.577 112.896L292.649 115.968C292.65 115.968 292.651 115.969 292.651 115.97C293.054 116.371 293.374 116.847 293.592 117.371C293.81 117.896 293.923 118.459 293.923 119.029C293.923 119.598 293.81 120.161 293.592 120.686C293.374 121.211 293.054 121.687 292.652 122.087C292.651 122.088 292.65 122.089 292.649 122.09L289.576 125.163C288.765 125.971 287.668 126.424 286.523 126.424C285.379 126.424 284.281 125.971 283.471 125.163L280.397 122.09C280.396 122.089 280.395 122.088 280.395 122.087C279.992 121.687 279.673 121.21 279.454 120.686C279.236 120.161 279.123 119.597 279.123 119.029C279.123 118.46 279.236 117.896 279.454 117.371C279.673 116.847 279.992 116.371 280.395 115.97Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.3 196.189C309.742 196.075 310.206 196.072 310.65 196.183C311.136 196.303 311.579 196.554 311.932 196.907C312.285 197.261 312.536 197.704 312.656 198.189C312.767 198.633 312.764 199.097 312.65 199.539L310.947 208.684C310.808 209.402 310.357 210.436 309.211 210.788C308.065 211.14 307.111 210.538 306.595 210.021L298.818 202.247C298.291 201.725 297.691 200.767 298.047 199.62C298.402 198.474 299.438 198.023 300.165 197.889C300.166 197.889 300.167 197.889 300.168 197.889L309.3 196.189ZM308.992 199.847L302.612 201.035L307.804 206.225L308.992 199.847Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M303.111 278.872C303.552 278.758 304.016 278.756 304.46 278.866C304.946 278.987 305.389 279.238 305.742 279.591C306.096 279.944 306.346 280.387 306.467 280.872C306.577 281.317 306.574 281.781 306.46 282.222L304.757 291.367C304.619 292.086 304.167 293.12 303.021 293.472C301.875 293.824 300.921 293.221 300.405 292.705L292.628 284.931C292.102 284.409 291.501 283.451 291.857 282.304C292.212 281.158 293.249 280.707 293.976 280.573C293.977 280.573 293.977 280.573 293.978 280.572L303.111 278.872ZM302.802 282.53L296.422 283.718L301.614 288.909L302.802 282.53Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.9804 214.4C36.4426 214.4 35.9166 214.559 35.4691 214.858C35.0216 215.157 34.6732 215.582 34.4675 216.078C34.2617 216.575 34.2078 217.122 34.3128 217.649C34.4177 218.176 34.6766 218.661 35.0569 219.041C35.4371 219.421 35.9216 219.68 36.4497 219.785C36.978 219.89 37.525 219.836 38.0215 219.63C38.5183 219.425 38.9432 219.076 39.2421 218.629C39.5409 218.182 39.7004 217.656 39.7004 217.118C39.7004 216.398 39.4139 215.706 38.9039 215.196C38.394 214.686 37.7021 214.4 36.9804 214.4ZM32.871 210.969C34.0873 210.157 35.5174 209.723 36.9804 209.723C38.942 209.723 40.8234 210.502 42.2108 211.889C43.5981 213.276 44.3776 215.157 44.3776 217.118C44.3776 218.581 43.9437 220.011 43.1308 221.228C42.3181 222.444 41.1629 223.392 39.811 223.952C38.4589 224.512 36.9717 224.657 35.5374 224.372C34.103 224.087 32.7849 223.383 31.7501 222.348C30.7155 221.314 30.0109 219.996 29.7255 218.562C29.44 217.127 29.5865 215.639 30.1465 214.288C30.7065 212.936 31.6548 211.781 32.871 210.969Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.355 54.4389C160.817 54.4389 160.291 54.5985 159.843 54.8974C159.396 55.1963 159.047 55.6208 158.842 56.1172C158.636 56.6139 158.582 57.1607 158.687 57.688C158.792 58.2152 159.051 58.6996 159.431 59.0798C159.811 59.4598 160.296 59.7188 160.824 59.8238C161.352 59.9289 161.899 59.875 162.396 59.6694C162.893 59.4637 163.317 59.115 163.616 58.6677C163.915 58.2206 164.075 57.6951 164.075 57.1576C164.075 56.4367 163.788 55.7451 163.278 55.2353C162.768 54.7255 162.076 54.4389 161.355 54.4389ZM157.245 51.0081C158.462 50.1956 159.892 49.7617 161.355 49.7617C163.316 49.7617 165.198 50.5406 166.585 51.9276C167.972 53.3146 168.752 55.1959 168.752 57.1576C168.752 58.6205 168.318 60.0504 167.505 61.2667C166.692 62.4827 165.537 63.4309 164.185 63.9908C162.833 64.5507 161.346 64.6964 159.912 64.4112C158.477 64.1259 157.159 63.4221 156.124 62.3875C155.09 61.3533 154.385 60.0354 154.1 58.6007C153.814 57.166 153.961 55.6785 154.521 54.3269C155.081 52.9752 156.029 51.8205 157.245 51.0081Z",
    fill: "#333333"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.48
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_2016_22929)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.7432 150.902C84.9819 145.374 90.3342 142.831 95.9926 142.551C107.275 141.992 131.281 141.215 177.5 141.215C223.719 141.215 247.725 141.992 259.008 142.551C264.666 142.831 270.018 145.374 271.257 150.902C271.791 153.286 272.167 156.323 272.167 160.148C272.167 163.974 271.791 167.01 271.257 169.395C270.018 174.923 264.666 177.466 259.008 177.746C247.725 178.304 223.719 179.082 177.5 179.082C131.281 179.082 107.275 178.304 95.9926 177.746C90.3342 177.466 84.9819 174.923 83.7432 169.395C83.2089 167.01 82.8333 163.974 82.8333 160.148C82.8333 156.323 83.2089 153.286 83.7432 150.902Z",
    fill: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.48
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.259 203.458C186.119 201.621 185.368 199.835 183.674 199.109C182.33 198.533 180.334 198.016 177.499 198.016C174.702 198.016 172.721 198.519 171.378 199.086C169.647 199.816 168.889 201.634 168.757 203.508C168.302 209.929 167.415 226.013 168.697 239.986C168.861 241.775 169.609 243.506 171.256 244.226C172.6 244.814 174.616 245.349 177.499 245.349C180.334 245.349 182.33 244.832 183.674 244.256C185.368 243.529 186.125 241.742 186.28 239.906C187.577 224.452 186.721 209.506 186.259 203.458Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.332 205.212C229.537 202.227 227.982 199.319 225.081 198.584C221.128 197.583 217.452 198.069 214.797 198.786C212.064 199.525 210.338 202.001 209.874 204.794C207.262 220.547 206.366 232.089 206.059 238.151C205.908 241.139 207.483 244.045 210.384 244.781C214.257 245.762 217.865 245.315 220.507 244.621C223.337 243.878 225.089 241.274 225.504 238.377C227.997 220.96 228.96 210.609 229.332 205.212Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.666 205.212C125.461 202.227 127.016 199.319 129.917 198.584C133.87 197.583 137.546 198.069 140.201 198.786C142.934 199.525 144.661 202.001 145.124 204.794C147.736 220.547 148.632 232.089 148.939 238.151C149.091 241.139 147.515 244.045 144.614 244.781C140.741 245.762 137.133 245.315 134.492 244.621C131.661 243.878 129.91 241.274 129.495 238.377C127.002 220.96 126.038 210.609 125.666 205.212Z",
    fill: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_di_2016_22929)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.1685 177.574C96.2198 194.372 100.114 221.03 106.588 247.214C109.188 257.726 117.997 265.395 128.769 266.507C140.678 267.736 157.809 269.015 177.5 269.015C197.192 269.015 214.323 267.736 226.232 266.507C237.004 265.395 245.813 257.726 248.412 247.214C254.887 221.03 258.781 194.372 260.833 177.574C260.231 177.659 259.621 177.716 259.008 177.746C247.725 178.305 223.719 179.082 177.5 179.082C131.281 179.082 107.275 178.305 95.9926 177.746C95.3794 177.716 94.7697 177.659 94.1685 177.574ZM183.676 199.109C185.37 199.835 186.12 201.621 186.261 203.458C186.722 209.505 187.578 224.451 186.281 239.906C186.127 241.742 185.37 243.529 183.676 244.255C182.332 244.831 180.335 245.349 177.501 245.349C174.618 245.349 172.602 244.813 171.257 244.226C169.611 243.506 168.862 241.774 168.698 239.985C167.417 226.013 168.304 209.929 168.758 203.508C168.891 201.634 169.648 199.816 171.379 199.085C172.723 198.519 174.704 198.015 177.501 198.015C180.335 198.015 182.332 198.533 183.676 199.109ZM225.082 198.584C227.983 199.319 229.539 202.226 229.333 205.212C228.961 210.609 227.998 220.959 225.505 238.376C225.09 241.273 223.339 243.877 220.508 244.621C217.866 245.314 214.259 245.762 210.385 244.78C207.484 244.045 205.909 241.139 206.061 238.15C206.368 232.088 207.263 220.546 209.876 204.793C210.339 202.001 212.066 199.525 214.799 198.786C217.454 198.068 221.13 197.582 225.082 198.584ZM125.668 205.212C125.462 202.226 127.018 199.319 129.919 198.584C133.872 197.582 137.547 198.068 140.202 198.786C142.935 199.525 144.662 202.001 145.126 204.793C147.738 220.546 148.633 232.088 148.941 238.15C149.092 241.139 147.517 244.045 144.616 244.78C140.742 245.762 137.135 245.314 134.493 244.621C131.663 243.877 129.911 241.273 129.496 238.376C127.003 220.959 126.04 210.609 125.668 205.212Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.48,
    filter: "url(#filter2_di_2016_22929)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.369 141.765C131.32 141.493 147.319 141.274 168.472 141.225C167.196 138.105 165.152 135.158 162.568 132.69C151.957 122.553 135.42 107.183 118.344 92.9863C112.292 87.9555 103.416 87.0553 97.4549 92.192C97.0506 92.5404 96.6808 92.8793 96.3574 93.2026C96.034 93.526 95.6952 93.8958 95.3468 94.3001C90.2101 100.262 91.1102 109.137 96.1412 115.189C103.881 124.498 111.97 133.648 119.369 141.765Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.631 141.765C243.031 133.648 251.119 124.498 258.86 115.189C263.89 109.137 264.791 100.262 259.654 94.3001C259.306 93.8958 258.967 93.526 258.643 93.2026C258.32 92.8793 257.95 92.5404 257.546 92.192C251.584 87.0553 242.708 87.9555 236.657 92.9863C219.581 107.183 203.043 122.553 192.433 132.69C189.849 135.158 187.805 138.105 186.528 141.225C207.682 141.274 223.68 141.493 235.631 141.765Z",
    fill: "#808080"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_2016_22929",
    x: 74.8333,
    y: 133.215,
    width: 221.333,
    height: 69.8672,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.270588 0 0 0 0 0.309804 0 0 0 0 0.356863 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2016_22929"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2016_22929",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.270588 0 0 0 0 0.309804 0 0 0 0 0.356863 0 0 0 0.48 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2016_22929"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_di_2016_22929",
    x: 86.1685,
    y: 169.574,
    width: 198.664,
    height: 123.441,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.270588 0 0 0 0 0.309804 0 0 0 0 0.356863 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2016_22929"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2016_22929",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.270588 0 0 0 0 0.309804 0 0 0 0 0.356863 0 0 0 0.48 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2016_22929"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_di_2016_22929",
    x: 83.9048,
    y: 80.75,
    width: 203.191,
    height: 85.0156,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.270588 0 0 0 0 0.309804 0 0 0 0 0.356863 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2016_22929"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2016_22929",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.270588 0 0 0 0 0.309804 0 0 0 0 0.356863 0 0 0 0.48 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2016_22929"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCart);
export default __webpack_public_path__ + "static/media/ic-cart.e8db63287ac220a2d9d9e1b0ae1c75e8.svg";
export { ForwardRef as ReactComponent };